// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFilePdfOutlinedSvg from "@fishx/icons-svg/es/asn/PFilePdfOutlined";
import FishxIcon from '../components/FishxIcon';

var PFilePdfOutlined = function PFilePdfOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFilePdfOutlinedSvg
  }));
};

PFilePdfOutlined.displayName = 'PFilePdfOutlined';
export default React.forwardRef(PFilePdfOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFilePdfOutlined.js
// module id = 3398
// module chunks = 0